import {combineReducers} from "redux";

import {reduceLatestQuery} from "@pg-mono/request-state";

import {fetchSelectedRegionDataTypes, ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";
import {IMapLayersStore, mapLayersSlice} from "../state/map_layers_slice";
import {appliedOffersReducer, IAppliedOffersStore} from "./applied_offers_reducer";
import {IOfferListMapListStore, offerListMapListReducer} from "./map_offer_list_reducer";
import {IMapSelectedPropertyStore, mapSelectedPropertyReducer} from "./map_selected_property_reducer";
import {offerListSelectedDataReducer} from "./offer_list_selected_data_reducer";

export interface IOfferListMapStore {
    list: IOfferListMapListStore;
    selectedProperty: IMapSelectedPropertyStore;
    selectedRegion: ISelectedRegion[];
    appliedOffers: IAppliedOffersStore;
    [mapLayersSlice.name]: IMapLayersStore;
}

export const offerListMapReducer = combineReducers({
    list: offerListMapListReducer,
    selectedProperty: mapSelectedPropertyReducer,
    appliedOffers: appliedOffersReducer,
    selectedRegion: offerListSelectedDataReducer(),
    selectedRegionLatestQuery: reduceLatestQuery(fetchSelectedRegionDataTypes),
    [mapLayersSlice.name]: mapLayersSlice.reducer
});
